
<ul class="wm-default-menu dropdown-menu export-menu dropdown-menu-right" *dropdownMenu >

  <ng-container *wmsFeature="preferences.project?.actions.build.appChef" >
     <p class="more-heading">{{locale.LABEL_BUILD}}</p>

  <li title="locale.LABEL_OPEN_APP_CHEF}}" *wmsFeature="preferences.project?.actions.build.appChef">
    <a name="wm-header-open-app-chef" target="_blank" href="https://www.wavemakeronline.com/AppChef">
      <i class="wms wms-widget-iframe-dialog"></i>
      <span class="menu-name">{{locale.LABEL_OPEN_APP_CHEF}}</span>
    </a>
  </li>

  <li class="divider dropdown-divider"></li>
  </ng-container>
   <p class="more-heading">{{locale.LABEL_EXPORT}}</p>

  <li *wmsFeature="preferences.project?.actions.sources.exportAsZip" title="{{locale.LABEL_ZIP_PROJECT}}">
    <a (click)="saveAndExport('projectAsZip')" name="wm-header-export-project-zip">
      <i class="wms wms-template-zip"></i><span class="menu-name">{{locale.LABEL_ZIP_PROJECT}}</span>
    </a>
  </li>
  <li *wmsFeature="preferences.project?.actions.sources.exportAsAngularZip" title="{{locale.LABEL_ZIP_PROJECT_AS_ANGULAR}}">
    <a (click)="saveAndExport('exportAsAngularZip')" name="wm-header-export-angular_project-zip">
      <i class="wms wms-template-zip"></i><span class="menu-name">{{locale.LABEL_ZIP_PROJECT_AS_ANGULAR}}</span>
    </a>
  </li>
  <li *wmsFeature="preferences.project?.actions.sources.exportAsReactZip && isPrism" title="{{locale.LABEL_ZIP_PROJECT_AS_REACT}}">
    <a (click)="saveAndExport('exportAsReactZip')" name="wm-header-export-react-zip">
      <i class="wms wms-template-zip"></i><span class="menu-name">{{locale.LABEL_ZIP_PROJECT_AS_REACT}}</span>
    </a>
  </li>
  <!-- &lt;!&ndash;
                      <li *wmsFeature="preferences.project?.actions.sources.cordovaExport" title="$root.locale.LABEL_ZIP_CORDOVA}}">
                          <a (click)="cordovaBuild()">
                              <i class="wms wms-mobile-build-cordova"></i><span class="menu-name">{{locale.LABEL_ZIP_CORDOVA}}</span>
                          </a>
                      </li>
  &ndash;&gt; -->

  <li title="{{locale.LABEL_WAR_PROJECT}}" [ngClass]="{'open': expanded}"  *wmsFeature="preferences.project.actions.build.exportAsWAR && preferences.project.profiles.configure" dropdown  role="menuitem"  (mouseenter)="expanded=true"  (mouseleave)="expanded=false" container="body"
      placement="right" class=" dropdown-submenu" >
    <a dropdownToggle name="wm-header-export-project-war dropdown-item dropdown-toggle" class="clearfix" (click)="false">
      <i class="wms wms-war pull-left"></i>
      <span class="menu-name pull-left">{{locale.LABEL_WAR_PROJECT}}</span>
      <span class="wms wms-caret-right pull-right"></span>
    </a>
    <ul *ngIf="expanded"  class="profiles wm-default-menu  custom-dropdown-menu "  role="menu"  >
      <li class="select-profile dropdown-header">{{locale.LABEL_SELECT_PROFILE}}</li>
      <li *ngFor="let profile of profiles" class="profile" [title]="locale['LABEL_PROFILES_' + profile.toUpperCase()] || profile" role="menuitem" >
        <a (click)="saveAndExport('projectAsWAR',profile)"   class="dropdown-item" fragment="nested-dropdowns">
          <i class="wms wms-profile-export"></i> <span class="menu-name">{{locale['LABEL_PROFILES_' + profile.toUpperCase()] || profile}}</span>
        </a>
      </li>
    </ul>
  </li>

  <li title="{{locale.LABEL_MOBILE_DOWNLOAD_REACTNATIVE}}" *wmsFeature="preferences.project.actions.sources.reactNativeExport">
    <a (click)="rnMobileBuild()" name="wm-header-build-for-phonegap">
      <i class="wms wms-mobile-build-react-native"></i><span class="menu-name">{{locale.LABEL_MOBILE_DOWNLOAD_REACTNATIVE}}</span>
    </a>
  </li>

   <!-- menu for reports -->
<ng-container *ngIf="preferences.workspace.user.exportProjectDependenciesReportEnabled || preferences.workspace.user.exportProjectSummaryReportEnabled">
  <li title="{{locale.LABEL_EXPORT_REPORTS}}" [ngClass]="{'open': expandExportReportSubmenu}"
    *wmsFeature="preferences.project.actions.build.exportAsWAR && preferences.project.profiles.configure" dropdown
    role="menuitem" (mouseenter)="expandExportReportSubmenu=true" (mouseleave)="expandExportReportSubmenu=false"
    container="body" placement="right" class=" dropdown-submenu">
    <a dropdownToggle name="wm-header-export-project-war dropdown-item dropdown-toggle" class="clearfix" (click)="false">
      <i class="wms wms-war pull-left"></i>
      <span class="menu-name pull-left">{{locale.LABEL_EXPORT_REPORTS}}</span>
      <span class="wms wms-caret-right pull-right"></span>
    </a>
    <ul *ngIf="expandExportReportSubmenu && (preferences.workspace.user.exportProjectDependenciesReportEnabled || preferences.workspace.user.exportProjectSummaryReportEnabled)" class="profiles wm-default-menu  custom-dropdown-menu " role="menu">
      <li class="select-profile dropdown-header">{{locale.LABEL_SELECT_REPORT}}</li>
      <li class="profile" *ngIf="preferences.workspace.user.exportProjectDependenciesReportEnabled" [title]="locale.LABEL_DEPENDENCIES_REPORT" role="menuitem">
        <a (click)="dependenciesReport()" class="dropdown-item" fragment="nested-dropdowns">
          <span class="menu-name">{{locale.LABEL_DEPENDENCIES_REPORT}}</span>
        </a>
      </li>
      <li class="profile" *ngIf="preferences.workspace.user.exportProjectSummaryReportEnabled" [title]="locale.LABEL_PROJECT_SUMMARY_REPORT" role="menuitem">
        <a (click)="projectSummaryReport()" class="dropdown-item" fragment="nested-dropdowns">
           <span class="menu-name">{{locale.LABEL_PROJECT_SUMMARY_REPORT}}</span>
        </a>
      </li>
    </ul>
  </li>
</ng-container>
  <ng-container  *ngIf="studioService.selectedOrganization?.mode !== 'ORG' && preferences.workspace.wmEnv === '_WM_STUDIO_ENV_'">
    <li title="{{locale.LABEL_ZIP_PREFAB}}"  *wmsFeature="preferences.project.actions.sources.prefabExport">
      <a (click)="saveAndExport('prefabAsZip')" name="wm-header-export-prefab-zip">
        <i class="wms wms-prefab-zip"></i><span class="menu-name">{{locale.LABEL_ZIP_PREFAB}}</span>
      </a>
    </li>
  </ng-container  >
  <ng-container   *ngIf="studioService.selectedOrganization?.mode !== 'ORG' && preferences.workspace.wmEnv === '_WM_STUDIO_ENV_'" >
    <li title="{{locale.LABEL_ZIP_TEMPLATEBUNDLE}}"*wmsFeature="preferences.project.actions.sources.templateBundleExport">
      <a (click)="saveAndExport('templateBundleAsZip')" name="wm-header-export-template-zip">
        <i class="wms wms-export-template-zip"></i><span
        class="menu-name">{{locale.LABEL_ZIP_TEMPLATEBUNDLE}}</span>
      </a>
    </li>
  </ng-container>

  <li title="{{locale.LABEL_MOBILE_DOWNLOAD_CORDOVA}}" *wmsFeature="preferences.project.actions.sources.cordovaExport">
    <a ng-click="mobileBuild('ZIP', 'CORDOVA')" name="wm-header-build-for-phonegap">
      <i class="wms wms-mobile-build-cordova"></i><span
      class="menu-name">{{locale.LABEL_MOBILE_DOWNLOAD_CORDOVA}}</span>
    </a>
  </li>
  <!-- For enterprise profiles -->
  <li title="{{locale.LABEL_PROJECT_AS_SHELL_TO_TEAM}}" *wmsFeature="!preferences?.workspace?.user?.appCustomizationEnabled && preferences.project.actions.build.publishProjectShellToTeam">
    <a (click)="saveAsProjectShell()" name="wm-project-saveasshell">
      <i class="wms wms-save"></i><span class="menu-name">{{locale.LABEL_PROJECT_AS_SHELL_TO_TEAM}}</span>
    </a>
  </li>

  <!-- For online profiles -->
  <ng-container  *ngIf="studioService.selectedOrganization?.mode === 'OWN' && preferences.workspace.wmEnv === '_WM_STUDIO_ENV_'">
    <li title="{{locale.LABEL_PROJECT_AS_SHELL_TO_WORKSPACE}}" *wmsFeature="preferences.project.actions.build.publishProjectShellToWorkspace">
      <a (click)="initiateSaveProjectShell()" name="wm-project-saveasshell">
        <i class="wms wms-save"></i><span class="menu-name">{{locale.LABEL_PROJECT_AS_SHELL_TO_WORKSPACE}}</span>
      </a>
    </li>
  </ng-container>

  <li title="{{locale.LABEL_PROJECT_AS_THEME_TO_TEAM}}" *wmsFeature="preferences.project.actions.build.publishThemeToTeam">
    <a (click)="publishThemeToTeam()" name="wm-project-saveastheme">
      <i class="wms wms-save"></i><span class="menu-name">{{locale.LABEL_PROJECT_AS_THEME_TO_TEAM}}</span>
    </a>
  </li>

  <!-- Project as WebComponent -->
  <li title="{{locale.LABEL_AS_WEB_COMPONENT_PROJECT}}" [ngClass]="{'open': expandedWC}"  *wmsFeature="preferences.project.actions.build.exportAsWebComponent" dropdown  role="menuitem"  (mouseenter)="expandedWC=true"  (mouseleave)="expandedWC=false" container="body"
      placement="right" class=" dropdown-submenu" >
    <a dropdownToggle name="wm-header-export-project-war dropdown-item dropdown-toggle" class="clearfix" (click)="false">
      <i class="wms wms-prefab-zip pull-left"></i>
      <span class="menu-name pull-left">{{locale.LABEL_AS_WEB_COMPONENT_PROJECT}}</span>
      <span class="wms wms-caret-right pull-right"></span>
    </a>
    <ul *ngIf="expandedWC"  class="profiles wm-default-menu  custom-dropdown-menu  dropdown-height"  role="menu">
      <li class="select-profile dropdown-header">{{locale.LABEL_SELECT_PROFILE}}</li>
      <li *ngFor="let profile of profiles" class="profile" [title]="locale['LABEL_PROFILES_' + profile.toUpperCase()] || profile" role="menuitem" >
        <a (click)="saveAndExport('projectAsWC', profile)"   class="dropdown-item" fragment="nested-dropdowns">
          <i class="wms wms-profile-export"></i> <span class="menu-name">{{locale['LABEL_PROFILES_' + profile.toUpperCase()] || profile}}</span>
        </a>
      </li>
    </ul>
  </li>

<!--  &lt;!&ndash; For enterprise profiles &ndash;&gt;-->
<!--  <li title="{{locale.LABEL_PROJECT_AS_SHELL_TO_TEAM}}" *wmsFeature="!preferences?.workspace?.user?.appCustomizationEnabled && preferences.project.actions.build.publishProjectShellToTeam">-->
<!--    <a (click)="saveAsProjectShell()" name="wm-project-saveasshell">-->
<!--      <i class="wms wms-save"></i><span class="menu-name">{{locale.LABEL_PROJECT_AS_SHELL_TO_TEAM}}</span>-->
<!--    </a>-->
<!--  </li>-->

  <ng-container  *wmsFeature="preferences.project?.actions?.build?.publishProjectCoreToTeam || preferences.project?.actions?.build?.appCustomizationEnabled || projectService.isPrefabType() ">
  <li class="divider dropdown-divider"></li>

  <p class="more-heading">Publish</p>
    <li class="dropdown"  *ngIf="isApplicationType && preferences?.workspace?.user?.appCustomizationEnabled && !studioFactory.showApplyMergeChangesWS">
      <a name="header-action-publish" class="dropdown-toggle action-vcs" [title]="locale.LABEL_PUBLISH_PROJECT_AS_CORE" (click)="publishProjectAsCore()">
        <div class="title"><i class=" wms wms-export"></i>
        <span class="menu-name">{{locale.LABEL_PUBLISH_PROJECT_AS_CORE}}</span></div>
      </a>
    </li>
    <wms-prefab-publish ></wms-prefab-publish>
  </ng-container>


  <ng-container  *wmsFeature="preferences.project?.actions.build.deploy">
  <li  class="divider dropdown-divider" ></li>
    <p class="more-heading">Deploy</p>
  </ng-container>
<!--    <ng-container *ngIf="deploymentService.checkingDeployStatus || deploymentService.deployInProgress || deploymentService.deploySetupDone">-->
<!--      <a name="header-action-deploy"  dropdownToggle *wmsFeature="preferences.project?.actions.build.deploy" [title]="(deploymentService.checkingDeployStatus && !deploymentService.deployInProgress)? locale['LABEL_HEADER_CHECKING_DEPLOY_TOOLTIP'] : deploymentService.deployInProgress ? locale['LABEL_HEADER_DEPLOYING_TOOLTIP'] : locale['LABEL_HEADER_DEPLOY_TOOLTIP']">-->
<!--        <i *ngIf="deploymentService.deployInProgress" class="title"><span class="fa-stack"><i class=" wi wi-cloud-queue fa-flip-horizontal fa-stack-2x"></i><i class="wi wi-loop fa-stack-1x fa-spin" [ngStyle]="{'line-height':'inherit'}"></i></span><span class="menu-name">{{locale.LABEL_HEADER_DEPLOY}}</span></i>-->
<!--        <i *ngIf="deploymentService.checkingDeployStatus && !deploymentService.deployInProgress" class="title"><i class="wm-icon wms wms-widget-spinner fa-spin"></i></i>-->
<!--&lt;!&ndash;        <i *ngIf="deploymentService.checkingDeployStatus && !deploymentService.deployInProgress" class="title"><i class="wm-icon wms wms-deploy"></i></i>&ndash;&gt;-->
<!--      </a>-->
<!--    </ng-container></li>-->

  <ng-container  *wmsFeature="preferences.project?.actions.build.deploy">
    <li  [title]="locale['LABEL_HEADER_DEPLOY_TOOLTIP']"     [ngClass]="{'disabled' : projectService.projectEdnDetails.branchType === 'BRANCH'}" >
      <a *ngIf="deploymentService.checkingDeployStatus && !deploymentService.deployInProgress"  ><i class="title"><i class="wm-icon wms wms-widget-spinner fa-spin"></i></i></a>
    <a name="header-action-deploy"  (click)="!deploymentService.deploySetupDone && deployToCloud()" *ngIf="!deploymentService.deploySetupDone && !deploymentService.checkingDeployStatus && !deploymentService.deployInProgress">
     <i class="wm-icon wms wms-deploy"></i><span class="menu-name ng-binding">Deploy</span>
    </a>
    </li>
  </ng-container>

  <ng-container *ngIf="deploymentService.deploySetupDone && !(deploymentService.checkingDeployStatus && !deploymentService.deployInProgress)">
    <li [title]="locale['LABEL_REDEPLOY']"  *ngIf="!deploymentService.checkingDeployStatus  && !deploymentService.deployInProgress">
      <a name="wm-deploy-app"  (click)="reDeployToCloud()">
        <i class="wm-icon wms wms-redeploy"></i>
        <span class="menu-name ng-binding">{{locale.LABEL_REDEPLOY}}</span>
      </a>
    </li>
    <li [title]="locale['LABEL_DEPLOY_STATUS']" *ngIf="deploymentService.deployInProgress">
      <a name="wm-deploy-app" (click)="showDeployStatus()">
        <i class="wm-icon wi wi-find-replace"></i>
        <span class="menu-name">{{locale.LABEL_DEPLOY_STATUS}}</span>
      </a>
    </li>
    <li [title]="locale['LABEL_HEADER_LAUNCH_APPLICATION']" *ngIf="!deploymentService.checkingDeployStatus && !deploymentService.deployInProgress && deploymentService.deployedAppUrl">
      <a name="wm-deploy-launch" target="_blank" [href]="deploymentService.deployedAppUrl">
        <i class="wm-icon wms wms-launchdeployedapp"></i><span class="menu-name">{{locale.LABEL_HEADER_LAUNCH_APPLICATION}}</span>
      </a>
    </li>
    <li [title]="locale['LABEL_MANAGE_APP']">
      <a name="wm-deploy-launch" target="_blank" [href]="deploymentService.manageAppUrl">
        <i class="wm-icon wms wms-manageapp"></i><span class="menu-name">{{locale.LABEL_MANAGE_APP}}</span>
      </a>
    </li>
  </ng-container>


<!--    <wms-push-changes-dialog [vcsAction]="'push'"></wms-push-changes-dialog>-->
<!--    <wms-deploy-dialog></wms-deploy-dialog>-->
<!--    <wms-deploy-confirm-dialog></wms-deploy-confirm-dialog>-->


</ul>


<!-- Zip Export Dialog -->
<wms-dialog id="zipExportDialog" customClasses="small wm-studio-dialog" >
  <wms-dialog-header [title]="exportDialogCaption || ''" (onClose)="close('zipExportDialog')"></wms-dialog-header>
  <wms-dialog-body>{{exportDialogContent}}</wms-dialog-body>
  <wms-dialog-footer>
    <button class="button-secondary btn app-button" name="wm-java-service-cancel" (click)="close('zipExportDialog')" title="{{locale.LABEL_CANCEL}}">
      <span class="btn-caption">{{locale.LABEL_CANCEL}}</span>
    </button>
    <button class="button-primary btn app-button" name="wm-java-service-add" (click)="downloadZipFile(zipFileId || '')" title="{{locale.LABEL_DOWNLOAD_NOW}}">
      <span class="btn-caption">{{locale.LABEL_DOWNLOAD_NOW}}</span>
    </button>
  </wms-dialog-footer>
</wms-dialog>

<!--Template for Job Response status dialog-->
<wms-dialog  id="warExportDialog" customClasses ="small wm-studio-dialog mobile-build-status-dialog"  keyboard="true">
  <wms-dialog-header  title='{{locale.TITLE_JOBS_POPUP}}' (onClose)="close('warExportDialog')">  </wms-dialog-header>
  <wms-dialog-body>
    <p class="status" class="col-xs-12">
      <i class="glyphicon glyphicon-ok" style="color:green"></i>
      <span class="status-message">
          {{jobType + locale.MESSAGE_QUEUE_SUCCESS}}
      </span>
    </p>
  </wms-dialog-body>
  <wms-dialog-footer>
    <button class="button-primary btn app-button" [title]="locale.LABEL_OK" (click)="close('warExportDialog')" >
      <span class="btn-caption">{{locale.LABEL_OK}}</span>
    </button>
  </wms-dialog-footer>
</wms-dialog>


<wms-dialog  id="DialogExportProjectAsProjectShell" customClasses="import-database-container-dialog small save-as-template wm-studio-dialog"  [content]="DialogExportProjectAsProjectShell">
</wms-dialog>
<ng-template #DialogExportProjectAsProjectShell>
  <wms-export-ProjectShell-dialog></wms-export-ProjectShell-dialog>
</ng-template>

<wms-dialog id="publishArtifactToTeam" customClasses="widget-config-dialog team-publish-dialog large project wm-studio-dialog select-platform" [content]="publishArtifactToTeam"></wms-dialog>
<ng-template #publishArtifactToTeam>
  <wms-publish-artifact-to-team-dialog [artifactType]="artifactType"  [dialogHeader]="dialogHeader" ></wms-publish-artifact-to-team-dialog>
</ng-template>
